import axios, { getData } from "lib/axios";

export const retrieveSummaryData = async ({ time_id }) => {
    return axios.get(`admin/payroll/${time_id}/summary`).then(getData);
}

export const completePayroll = async (time_id) => {
    return axios.get(`admin/payroll/${time_id}/submit`).then(getData);
}
